import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./HeroSection.css";

const HeroSection = () => {
  const [mainItem, setMainItem] = useState(null);      // Will hold data["1"]
  const [subtitleItems, setSubtitleItems] = useState([]); // Will hold data["2"], ["3"], etc.

  // Convert base64 to a usable image URL
  const base64ToImageUrl = (base64) => {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    const blob = new Blob([bytes], { type: "image/jpeg" });
    return URL.createObjectURL(blob);
  };

  useEffect(() => {
    axios
    .get("https://khanehyeghtesad.com:8000/api/article/gettitr/") // Removed headers
    .then((response) => {
      const data = response.data;

        // "mainItem" is data["1"]
        const mainData = data["1"];
        if (!mainData) return; // If there's no "1", do nothing.

        // mainItem.article_id => "qcZ6J5QB6PXStfhMOpdH"
        // mainItem.article => the actual article object
        const { article_id, article } = mainData;

        // Convert base64 image if present
        if (article?.image_file) {
          article.image_file = base64ToImageUrl(article.image_file);
        }

        // Now store the combined data however you prefer:
        // We'll nest them into a single object, so we can easily pass it around:
        const mainItemObj = {
          article_id,
          ...article, // This merges all fields from "article" into "mainItemObj"
        };
        setMainItem(mainItemObj);

        // For subtitles, do the same with keys "2", "3", "4", "5"
        const subKeys = ["2", "3", "4", "5"];
        const collected = subKeys
          .map((key) => {
            const item = data[key];
            if (!item) return null;

            // item => { article_id, article: {...} }
            const { article_id: subId, article: subArticle } = item;
            if (subArticle?.image_file) {
              subArticle.image_file = base64ToImageUrl(subArticle.image_file);
            }
            return {
              article_id: subId,
              ...subArticle,
            };
          })
          .filter(Boolean);

        setSubtitleItems(collected);
      })
      .catch((error) => {
        console.error("Error fetching articles:", error);
      });
  }, []);

  // If mainItem is not set yet => show Loading
  if (!mainItem) {
    return <div>در حال بارگذاری...</div>;
  }

  return (
    <section className="hero-section">
  <div className="hero-container">
    {/* Subtitles: 25% Width */}
    <div className="subtitles">
  {subtitleItems.map((sub, idx) => (
    <Link
      to={`/article/${sub.slug}`}
      key={idx}
      className="subtitle-link"
    >
      <div
        className="subtitle"
        style={{
          backgroundImage: `url(${sub.image_file || "https://placehold.co/300x200"})`,
        }}
      >
        
        <h3>{sub.title}</h3>
        <p>{sub.jalali_full_date || "تاریخ نامشخص"}</p>
      </div>
    </Link>
  ))}
</div>


    {/* Main Article: 75% Width */}
    <div className="featured-article">
      <div className="featured-image">
        <Link to={`/article/${mainItem.slug}`}>
          <img
            src={
              mainItem.image_file
                ? mainItem.image_file
                : "https://placehold.co/600x400"
            }
            alt={mainItem.title}
          />
        </Link>
      </div>

      <div className="featured-overlay">
        <div className="main-title">
          <div className="title-caption-wrapper">
            <Link to={`/article/${mainItem.slug}`}>
              <p className="quote">"{mainItem.quote}"</p>
              <h1>{mainItem.title}</h1>
              
              <p className="hero-main-caption">
                  {mainItem.caption.length > 100
                    ? `${mainItem.caption.substring(0, 100)}...`
                    : mainItem.caption}
                </p>
            </Link>
          </div>
          <p className="meta">
            {mainItem.jalali_full_date || "تاریخ نامشخص"}
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

  );
};

export default HeroSection;
